import styled from 'styled-components';

export const OutlineButton = styled.button`
  cursor: pointer;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  height: 40px;
  border-radius: 8px;
  padding: 0 20px;
  box-sizing: border-box;

  box-shadow: none;
  background: #141c18;
  color: #e6eaec;
  border: 1px solid #3d4952;
  position: relative;
  transition:
    border-color 0.15s ease-in,
    background 0.15s ease-in;
  &:hover {
    background: #232e35;
    border-color: #47b972;
  }
  &:disabled {
    opacity: 0.5;
    &:hover {
      background: #141c18;
      border-color: #3d4952;
    }
  }

  &.size-sm {
    height: 30px;
    padding: 0 10px;
  }

  &.loading::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.5) url(/images/loader.svg) no-repeat 50% 50%;
    background-size: 18px auto;
  }
`;
